import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { tasks } from "lobbie";

export interface ITaskViewEditDrawerState {
    show: boolean;
    task?: tasks.ITask;
    onCancel?: () => void; // we are just closing the drawer, maybe refresh, maybe not
    onAction?: () => void; // primary task action takes over, close all else
    onUpdate?: (updatedTask: tasks.ITask) => void; //the task was updated in some way
}

export const initialStateTaskViewEdit: ITaskViewEditDrawerState = {
    show: false,
    task: undefined,
    onCancel: undefined,
    onAction: undefined,
};

const taskViewSlice = createSlice({
    name: "taskViewEditDrawerSlice",
    initialState: initialStateTaskViewEdit,
    reducers: {
        showTaskViewEditDrawer: (
            _state,
            action: PayloadAction<Omit<ITaskViewEditDrawerState, "show">>,
        ) => {
            return {
                ...action.payload,
                show: true,
            };
        },
        hideTaskViewEditDrawer: (state) => {
            return {
                ...state,
                show: false,
            };
        },
        updateCurrentTask: (
            state,
            action: PayloadAction<
                Omit<ITaskViewEditDrawerState, "show" | "onCancel" | "onAction" | "onUpdate">
            >,
        ) => {
            state.task = action.payload.task;
        },
    },
});

export const { showTaskViewEditDrawer, hideTaskViewEditDrawer, updateCurrentTask } =
    taskViewSlice.actions;
export default taskViewSlice.reducer;
